import React from "react";
import { colors } from "../../colors/color";
import { Small } from "../../typography/Body";
import { Flex } from "../FlexHelpers";
import { ItemSelectorPanel } from "./ItemSelectorPanel";
import { Avatar } from "../../avatar/Avatar";

type AvatarItemSelectorPanelProps = {
    items: {
        avatar?: { 
            text:string,
            tooltip?:string
            color?:string,
            backgroundColor?:string
        },
        primaryText: string,
        secondaryText?: string,
        selectionValue: string,
        selected?: boolean;
    }[],
    pageSize?: number,
    searchPlaceholder?: string,
    noItemsElement?: React.ReactNode,
    selectMode?: 'onOff' | 'button-add-remove' | 'button-select',
    onSelectionChanged?: (selectionValue: string, checked: boolean) => void,
    onSaveChanges?: () => void, // Optional save changes function
    onCancel?: () => void; // Optional cancel function
};
export function AvatarItemSelectorPanel (props: AvatarItemSelectorPanelProps): JSX.Element
{
    const noItems = props.noItemsElement || <div>Ingen resultater</div>;

    const itemHeight = 48;
    const pageSize = props.pageSize || 10;
    const itemListMinHeight = ((itemHeight + 16) * pageSize) + 'px';

    return (
        <ItemSelectorPanel
            pageSize={pageSize}
            searchPlaceholder={props.searchPlaceholder || "Søg..."}
            noItemsElement={noItems}
            itemListMinHeight={itemListMinHeight}
            items={props.items.map(i => ({
                selectionValue: i.selectionValue,
                selected: i.selected,
                searchTexts: [i.primaryText, i.secondaryText || ''],
                renderComponent: (
                    <Flex gap={8} alignItems="center" style={{ height: itemHeight +'px' }}>
                        <Flex style={{ flexGrow: 0, minWidth: 42 }} alignItems="center" justifyContent="center">
                            {i.avatar &&
                                <Avatar
                                    backgroundColor={i.avatar.backgroundColor || colors.icon.active}
                                    size="42px"
                                    toolTip={i.avatar?.tooltip ? <span>{i.avatar.tooltip}</span> : undefined}>
                                        
                                    {i.avatar.text}

                                </Avatar>
                            }
                        </Flex>
                        <Flex flexDirection="column" style={{ flexGrow: 1 }}>
                            <div>{i.primaryText}</div>
                            <Small>{i.secondaryText}</Small>
                        </Flex>
                    </Flex>
                )
            }))}
            selectMode={props.selectMode}
            onSelectionChanged={props.onSelectionChanged}
            onSaveChanges={props.onSaveChanges}
            onCancel={props.onCancel}
        />
    );
}